import { render, staticRenderFns } from "./suitabilitySurvey.vue?vue&type=template&id=4118d1dd&scoped=true&"
import script from "./suitabilitySurvey.vue?vue&type=script&lang=js&"
export * from "./suitabilitySurvey.vue?vue&type=script&lang=js&"
import style0 from "./suitabilitySurvey.vue?vue&type=style&index=0&id=4118d1dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4118d1dd",
  null
  
)

export default component.exports